import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StandardResponse } from 'src/app/models/common.model';
import { Course } from 'src/app/models/course.model';
import { Enrollment } from 'src/app/models/enrollment.model';
import { User } from 'src/app/models/user.model';
import { CourseService } from 'src/app/services/course.service';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-student',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.scss'],
})
export class CoursesListComponent implements OnInit {
  //get list of the courses
  courses: Course[] = [];
  enrollments: Enrollment[] = [];
  today = new Date();

  constructor(
    private courseService: CourseService,
    private enrollmentService: EnrollmentService,
    private route: Router,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.courseService
      .getCourses()
      .subscribe((response: StandardResponse<Course>) => {
        this.courses = response.results;
      });

    const student = this.userService.getCurrentUser()?.id;
    if (student) {
      this.enrollmentService
        .findEnrollmentsByStudent(this.userService.getCurrentUser()?.id)
        .subscribe((response) => {
          this.enrollments = response;
        });
    }
  }

  popoverVisible = false;

  togglePopover(): void {
    this.popoverVisible = !this.popoverVisible;
  }

  isEnrolled(courseId: string) {
    return this.enrollments.find(
      (enrollment: Enrollment) => enrollment.courseId == courseId
    );
  }

  /**
   * Method to enroll the student based on the selection
   */
  enroll(course: Course) {
    //check if the student has already been enrolled or not
    //if enrolled, send the student to course page
    //otherwise to the enrollment/payment page.
    const user = this.userService.getCurrentUser();
    if (!user) {
      this.route.navigate(['/course-list'], { state: { course } });
      return;
    }
    const enrolled = this.isEnrolled(course.id);
    !enrolled
      ? this.route.navigate(['/home/student/enroll'], { state: { course } })
      : this.route.navigate(['/home/student/enrolled-course'], {
          state: { course, enrollments: this.enrollments },
        });
  }
}
